<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <b-tabs v-model="activeTab" card class="nav-fill">
            <b-tab v-for="(info, name) in tabInfo" :key="name" :title="info.title" @click="changeTab(name)">
              <TermsManagementList v-if="currentTab == name" :currentTab="currentTab" :fieldobj="fieldobj"/>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { EventBus } from '../../event-bus';
import Breadcrumb from '../../../components/Breadcrumb';
import TermsManagementList from "./component/TermsManagementList";

export default {
  name:'TermsManagement',
  components: {
    TermsManagementList,
    Breadcrumb
  },
  data() {
    return {

      activeTab: null,
      currentTab: 'terms',

      tabInfo: {
        terms: {title: '이용약관'},
        privacy: {title: '개인정보보호정책'},
        copyright: {title: '저작권 보호방침'},
      },

      fieldobj: {
        fieldItems: [{
          'selectcheck': {
            'label': '선택', 'class': 'text-center', 'tdClass': 'text-vmiddle',
            'thStyle': {'vertical-align': 'middle'},
            'headerTitleSlot': 'selectcheck',
          }
        }, {
          'rnum': {
            'label': '번호',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle', 'width': '10%'}
          }
        }, {
          'use_yn': {
            'label': '노출여부',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle', 'width': '10%'}
          }
        }, {
          'subject': {
            'label': '제목',
            'class': 'text-left',
            'thStyle': {'vertical-align': 'middle', 'text-align': 'center'}
          }
        }, {
          'reg_name': {
            'label': '등록자',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle', 'text-align': 'center', 'width': '10%'}
          }
        }, {
          'reg_date': {
            'label': '등록일',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle', 'width': '10%'}
          }
        }],
        dateMonthButtons: [
          { item_name: '전체', item_code:'dayall', state: true },
          //{ item_name: '오늘', item_code:'-1|days',state: false },
          { item_name: '1주일', item_code:'-7|days',state: true },
          { item_name: '1개월', item_code:'-1|months',state: false },
          { item_name: '6개월', item_code:'-6|months',state: false },
          { item_name: '1년', item_code:'-1|years',state: false },
        ],
        calendarLocale: {
          "format": "YYYY-MM-DD",
          "separator": "~",
          "applyLabel": "적용",
          "cancelLabel": "취소",
          "fromLabel": "From",
          "toLabel": "To",
          "customRangeLabel": "Custom",
          "weekLabel": "W",
          "daysOfWeek": [
            "일", "월", "화", "수", "목", "금", "토"
          ],
          "monthNames": [
            "1월", "2월", "3월", "4월", "5월", "6월",
            "7월", "8월", "9월", "10월", "11월", "12월"
          ],
          "firstDay": 1
        },
      }

    }
  },
  watch: {
  },
  mounted: function() {
    var self = this;

    //등록, 수정으로 페이지 진입시 banner_type session 확인
    //있다면 queryParams.banner_type에 할당
    setTimeout(function() {
      if (typeof self.$session.get('page_term_type') != 'undefined') {
        self.currentTab = self.$session.get('page_term_type');

        //관리별 b-tabs 활성화
        let keys = Object.keys(self.tabInfo);
        let index = keys.indexOf(self.currentTab);
        self.activeTab = index;
      }
      self.changeTab(self.currentTab);
    }, 100);
  },

  methods: {

    //탭 변경
    changeTab (newTap) {
      // 마지막 메뉴명 변경을 위한 이벤트 버스 추가
      this.$session.set('page_term_type', newTap);
      this.currentTab = newTap;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/site/terms/TermsManagement.vue